import styled from 'styled-components'
import { themeStyles } from '../../../styles/theme'

export const StyledQRContainer = styled.div`
  border: 8px solid ${themeStyles.colors.black.main};
  padding: 0.5em;
  border-radius: 38px;
`
